import { defineStore } from 'pinia'

export const useStore = defineStore('main', {
  state: () => ({
    ready: false,
    guest: false,
    language: 'en',
    user: {},
    token: '',
    config: {
      environment: '',
      platformUrl: '',
      cdnRoot: ''
    },
    categoryTitles: {},
    breadcrumbs: []
  }),
  getters: {
    logos: () => ({
      noText: 'https://cdn.ecoonline.com/assets/logos/brand/logomark.svg',
      withText: 'https://cdn.ecoonline.com/assets/logos/brand/logo.svg'
    }),
    lang: state => state.user.site_language ?? state.language,
    fullBreadcrumbs: state => {
      const { $i18n } = useNuxtApp()
      return [
        {
          title: $i18n.t(23),
          path: '/'
        },
        ...state.breadcrumbs
      ]
    }
  }
})
